"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastAlertContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
/**
 * Use this for things like links or buttons that are actionable with a mouse in the Toast, but not
 * for screen readers since they won't see it. Please ensure you've looked over the documentation
 * for interactive Toasts to avoid accessibility issues.
 */
const ToastAlertContent = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    role: "alert"
  }, rest), children);
};
exports.ToastAlertContent = ToastAlertContent;
//# sourceMappingURL=ToastAlertContent.js.map